import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import React from 'react'

interface IconProps {
  icon: IconDefinition
  className?: string
  size?: 'xs' | 'sm' | 'lg' | '2x' | '3x' | '4x' | '5x' | '6x' | '7x' | '8x' | '9x' | '10x'
  spin?: boolean
  pulse?: boolean
  style?: React.CSSProperties
  onClick?: React.MouseEventHandler
}

export default function Icon({ icon, className, size, spin, pulse, style, onClick }: IconProps) {
  return (
    <FontAwesomeIcon
      icon={icon}
      className={className}
      size={size}
      spin={spin}
      spinPulse={pulse}
      // @ts-ignore
      style={style}
      onClick={onClick}
    />
  )
}
